<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Faculty Load Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
           <v-col cols="12" sm="1">
           </v-col>
                <v-col cols="12" sm="3">
                <p><v-icon color="error">*</v-icon><b>Academic Year</b></p> 
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay"  :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"/>
            </v-col>
                 <v-col cols="12" sm="3"> 
                     <br>
                    <v-btn color="mb-2 button"  @click="fetchLoadData" >Fetch</v-btn>
                </v-col>
            </v-row>
       </v-card>

     <v-card class="box" v-if="load_list.length > 0">
     <v-data-table  :headers="headers" :items="load_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Load Data</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      title:"",
      description:"",
      headers:[
      { text: "SR NO", value: "count" },
      { text: "Faculty", value: "tt_faculty" },
      { text: "Course Timetables", value: "coursr_tt" },
      { text: "Events", value: "event_tt" },
      ],
      ay_list:[],ay:"",fetch_loader:false,load_list:[]
  }),
   methods: {
       fetchLoadData(){
            const data = {
            ay:this.ay
        };
            this.overlay = true;
            this.fetch_loader = true;
            this.load_list=[]
            axios
                .post("/TimeTable/fetchLoadData",data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.load_list=res.data.main_list
                    } else {
                        this.form_no_list=[]
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                    this.fetch_loader = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                    this.fetch_loader = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.fetch_loader = false;
                });
       },
    onLoad(){
        axios
        .post("TimeTable/getFacultyLoad")
        .then((res) => {
            if (res.data.flag == "YES") {
                (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            } else {
                this.showSnackbar("#b71c1c", res.data.status_reason);
            }
        })
        .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>